import styled from 'styled-components';

export default styled.div`
  && {
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background-size: cover;
    position: relative;
    background: #eeeeee;
  }
  .boxLogin {
    background: white;
    width: 500px;
    border-radius: 10px;
  }
  .header {
    position: relative;
    width: 100%;
    height: 50px;
    background: #80a445;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
  .logo {
    position: absolute;
    left: calc(50% - 50px);
    bottom: 0;
    border-radius: 50%;
    height: 100px;
    width: 100px;
    background-color: #80a445;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .section {
    text-align: center;
    padding-top: 50px;
    padding-bottom: 70px;
  }
  .title {
    font-weight: 700;
    font-size: 30px;
    margin-bottom: 0;
    color: #80a445;
    line-height: 34px;
    letter-spacing: 0.08em;
  }
  .titleMini {
    color: #80a445;
    font-weight: 400;
    letter-spacing: 0.06em;
    line-height: 16px;
    font-size: 14px;
    margin-bottom: 0;
  }
  .text {
    margin-top: 35px;
    margin-bottom: 28px;
    font-size: 16px;
    font-weight: 300;
  }
  .input {
    margin-top: 4px;
    height: 40px;
  }
  .btnSubmit {
    border-radius: 5px;
    background-color: #ff8a00;
    border: none;
    width: 100%;
    height: 60px;
    color: white;
    font-size: 16px;
  }
`;
